"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));
exports.camelCaseKeys = function (rawFlags) {
    var flags = {};
    for (var rawFlag in rawFlags) {
        // Exclude system keys
        if (!rawFlag.startsWith('$')) {
            var camelCasedKey = lodash_camelcase_1.default(rawFlag);
            flags[camelCasedKey] = rawFlags[rawFlag];
        }
    }
    return flags;
};
//# sourceMappingURL=utils.js.map